export default "__VITE_ASSET__CuFSnrgp__"